const topics = [
  { id: 1, name: '暑期档电影', heat: '986万', color: 'primary' as const },
  { id: 2, name: '悬疑剧推荐', heat: '872万', color: 'accent' as const },
  { id: 3, name: '港片经典', heat: '765万', color: 'secondary' as const },
  { id: 4, name: '综艺搞笑名场面', heat: '698万', color: 'primary' as const },
  { id: 5, name: '国产高分剧集', heat: '621万', color: 'accent' as const },
  { id: 6, name: '科幻大片', heat: '554万', color: 'secondary' as const },
  { id: 7, name: '古装剧天花板', heat: '487万', color: 'primary' as const },
  { id: 8, name: '动作片精选', heat: '432万', color: 'accent' as const },
  { id: 9, name: '纪录片推荐', heat: '389万', color: 'secondary' as const },
];

const colorMap = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', bar: 'bg-primary-500', badge: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', bar: 'bg-accent-500', badge: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', bar: 'bg-secondary-500', badge: 'bg-secondary-500' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">全网热议的影视话题，看看大家都在讨论什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topics.map((topic) => {
            const c = colorMap[topic.color];
            return (
              <div key={topic.id} className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer overflow-hidden">
                <div className="p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <span className={`w-2 h-2 rounded-full ${c.badge} flex-shrink-0`}></span>
                        <span className="text-xs text-foreground-400">#{topic.id}</span>
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">{topic.name}</h3>
                    </div>
                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${c.bg} ${c.text} flex-shrink-0 ml-3 whitespace-nowrap`}>{topic.heat}热度</span>
                  </div>
                  <div className="h-1.5 bg-background-200 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full ${c.bar} transition-all`} style={{ width: `${65 - topic.id * 5}%` }}></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}